import { IModelOptions } from "../interfaces/IModelOptions";
import { MODEL, MODELNAME } from "../utils";

/**
 * Decorator that will determine the type of model that is being created
 * 
 * @param modelName: string
 *   The model name that will be stored in the database
 * @param options?: IModelOptions
 *   The options that the model should follow when building out the model
 * @return Function
 *   Will return a function that will be used by the Reflection API to build out everything on the object
 */
export function Model(modelName: string, options?: IModelOptions) {
    options = options || {};
    return (constructor: any) => {
        Reflect.defineMetadata(MODEL, options, constructor);
        Reflect.defineMetadata(MODELNAME, modelName, constructor);
        Reflect.defineMetadata(MODELNAME, modelName, constructor.prototype);
    }
}